import type { IconSvgObject } from './types';

const MinusPlusCircle02Icon: IconSvgObject = [
  ["path", { d: "M16 8L8 16M14.5 16V14.5M14.5 14.5V13M14.5 14.5H13M14.5 14.5H16M8 9.5H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default MinusPlusCircle02Icon;
